import { render, staticRenderFns } from "./takecare.vue?vue&type=template&id=8f1681d2&scoped=true&"
import script from "./takecare.vue?vue&type=script&lang=js&"
export * from "./takecare.vue?vue&type=script&lang=js&"
import style0 from "./takecare.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./takecare.vue?vue&type=style&index=1&id=8f1681d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1681d2",
  null
  
)

export default component.exports